var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9995 98.9768C77.8461 98.9768 98.7991 78.0239 98.7991 52.1772C98.7991 26.3306 77.8461 5.37769 51.9995 5.37769C26.1529 5.37769 5.19995 26.3306 5.19995 52.1772C5.19995 78.0239 26.1529 98.9768 51.9995 98.9768ZM51.9995 104.177C80.718 104.177 103.999 80.8958 103.999 52.1772C103.999 23.4587 80.718 0.177743 51.9995 0.177743C23.281 0.177743 0 23.4587 0 52.1772C0 80.8958 23.281 104.177 51.9995 104.177Z",
    fill: "#556581"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7764 72.4004C30.7608 71.3851 30.7608 69.7388 31.7764 68.7235L68.5455 31.9541C69.5608 30.9388 71.2071 30.9388 72.2224 31.9541C73.2377 32.9694 73.2377 34.6157 72.2224 35.631L35.4533 72.4004C34.4377 73.4157 32.7917 73.4157 31.7764 72.4004Z",
    fill: "#556581"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7764 31.9541C32.7919 30.9388 34.438 30.9388 35.4535 31.9541L72.2226 68.7235C73.2379 69.7388 73.2379 71.3851 72.2226 72.4004C71.2073 73.4157 69.561 73.4157 68.5457 72.4004L31.7764 35.631C30.7611 34.6157 30.7611 32.9694 31.7764 31.9541Z",
    fill: "#556581"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.373514e5e2158f194178f8b073625435.svg";
export { ForwardRef as ReactComponent };